// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Auth Loading State */
.auth-loading {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    background: #0a0f14;
    color: #9ca3af;
    font-family: 'DM Sans', system-ui, -apple-system, sans-serif;
  }
  
  .auth-loading__spinner {
    width: 40px;
    height: 40px;
    border: 3px solid #2d3a4f;
    border-top-color: #10b981;
    border-radius: 50%;
    animation: authSpin 0.8s linear infinite;
  }
  
  @keyframes authSpin {
    to { transform: rotate(360deg); }
  }`, "",{"version":3,"sources":["webpack://./src/components/auth/ProtectedRoute.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,mBAAmB;IACnB,cAAc;IACd,4DAA4D;EAC9D;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,wCAAwC;EAC1C;;EAEA;IACE,KAAK,yBAAyB,EAAE;EAClC","sourcesContent":["/* Auth Loading State */\n.auth-loading {\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 16px;\n    background: #0a0f14;\n    color: #9ca3af;\n    font-family: 'DM Sans', system-ui, -apple-system, sans-serif;\n  }\n  \n  .auth-loading__spinner {\n    width: 40px;\n    height: 40px;\n    border: 3px solid #2d3a4f;\n    border-top-color: #10b981;\n    border-radius: 50%;\n    animation: authSpin 0.8s linear infinite;\n  }\n  \n  @keyframes authSpin {\n    to { transform: rotate(360deg); }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
